import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { SpinnerBox } from '@flipster/react/design-system/spinner';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import DocumentSearchIcon from '@flipster/ui/assets/svgs/document-search.svg';

import { mobileTabInfoMapper, spotMobileTabInfoMapper } from '../../../constants';
import { marketPageBunja } from '../../../state';
import { SortKey, TableListProps } from '../../../types';
import { NoData } from '../no-data/no-data';
import { PageLink } from '../page-link';
import { MobileListHeader } from './mobile-list-header';
import { MobileRow } from './mobile-row';

export const MobileList = ({
  tab,
  items,
  pagination,
  setPage,
  getPageHref,
  isSearching,
  isLoading,
  onChangeSort,
}: TableListProps) => {
  const { tab: marketTab, discoverCursorAtom } = useBunja(marketPageBunja);
  const { sort } = useAtomValue(discoverCursorAtom);
  const tabInfo = marketTab === 'spot' ? spotMobileTabInfoMapper[tab] : mobileTabInfoMapper[tab];

  if (!isLoading && !items?.length) {
    return (
      <section className={vstack({ gap: 8, height: '100%', py: 40, color: 'content.default.level-1' })}>
        <DocumentSearchIcon />
        {isSearching ? <NoData /> : <FormattedMessage id='Common.r251015.No_data_found' />}
      </section>
    );
  }

  return (
    <section>
      {!isSearching && (
        <MobileListHeader
          columns={tabInfo}
          sortKey={sort.sortKey}
          sortOrder={sort.sortOrder}
          onChangeSorting={([sortKey, sortOrder]) => {
            onChangeSort({ sortKey: sortKey as SortKey, sortOrder });
          }}
        />
      )}
      <ul
        className={css({
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderColor: 'border.default.level-1',
        })}
      >
        {isLoading && <SpinnerBox css={{ padding: '40px 0' }} />}
        {items?.map((v) => <MobileRow key={`${tab}_${v.symbol}`} tab={tab} item={v} />)}
      </ul>
      <PageLink {...pagination} onChange={setPage} getPageHref={getPageHref} />
    </section>
  );
};
